import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/Header/Header';
import NavigationBar from '../components/NavigationBar';
import EnvironmentSwitcher from '../components/EnvironmentSwitcher';
import './MainLayout.css';

const MainLayout: React.FC = () => {
  return (
    <div className="main-layout">
      <Header />
      <main className="content">
        <Outlet />
      </main>
      <NavigationBar />
      {/* Only show the environment switcher in non-production environments */}
      {process.env.NODE_ENV !== 'production' && <EnvironmentSwitcher />}
    </div>
  );
};

export default MainLayout;